import { render, staticRenderFns } from "./packagelist.vue?vue&type=template&id=048a0559&scoped=true&"
import script from "./packagelist.vue?vue&type=script&lang=js&"
export * from "./packagelist.vue?vue&type=script&lang=js&"
import style0 from "./packagelist.vue?vue&type=style&index=0&id=048a0559&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a0559",
  null
  
)

export default component.exports